<style lang="scss">
.autocomplete-input {
    position: relative;

    .v-input__append-outer {
        margin: 2px;
    }

    .custom-menu {
        width: 100%;
        max-width: 100%;
        max-height: 305px;
        background-color: #fff !important;

        position: absolute;
        bottom: -1px;        
        left: 0;
        z-index: 1003;

        transform: translate(0, 100%);

        .v-list-item__content {
            overflow: hidden;
        }

        .v-list-item__title {
            color: rgba(0, 0, 0, 0.87) !important;
            text-align: left;
            font-weight: 400;
            text-transform: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            width: 100%;
        }

        .v-list-item {
            justify-content: start;
            max-width: 100%;
            // font-family: "PT Sans";
            letter-spacing: 0.3px;

            &.v-list-item--active {
                .v-list-item__title {
                    color: #1976d2 !important;
                    caret-color: #1976d2 !important;
                }
            }
        }

        .v-btn__content {
            width: 100%;
        }

        .v-list {
            padding-top: 0;
            padding-bottom: 0;
        }
    }

}
</style>

<template>
    <div>
        <label class="is-size-4 mb-1">
            {{ label }}
        </label>

        <div class="autocomplete-input">
            <v-text-field
                v-model="fieldValue"
                v-bind="fieldAttrs"
                @focus="isFocus = true"
                @blur="isFocus = false"
                @keydown="changeItemByKey"

                :style="{'height': fieldHeight}"
                :height="fieldHeight"

                validate-on-blur
                >
                <template #append-outer>
                    <v-slide-y-transition hide-on-leave>
                        <div
                            v-if="isListActive"
                            @mouseover="isMouseOver = true"
                            @mouseleave="isMouseOver = false"
                            class="v-menu__content -theme--light custom-menu"
                            >
                            <div class="v-list">
                                <v-btn
                                    block
                                    text
                                    v-for="(item, key) in fieldItems" :key="key"
                                    @click="changeItem(item.value)"
                                    class="v-list-item v-list-item--link theme--light"
                                    :class="{
                                        'primary--text v-list-item--active': item.value == fieldValue,
                                        'v-list-item--active': key == listKey
                                    }"
                                    >
                                    <div class="v-list-item__title">
                                        {{ item.value }}
                                    </div>
                                </v-btn>
                            </div>
                        </div>
                    </v-slide-y-transition>
                </template>
            </v-text-field>

            <label class="is-size-5">{{ comment }}</label>
        </div>

        <label class="is-size-5">
            {{ comment }}
        </label>
    </div>
</template>

<script>
// У v-autocomplete есть атрибут return-object, для возврата item целиком
// no-filter позволяет оставить server side фильтрацию

export default {
    props: {
        value: [Number, String, Boolean],
        fieldHeight: String,
        // forceValue: {
        //     type: [Number, String, Boolean], // подстановка значения
        //     default: false
        // },
        itemText: String,
        items: Array,
        label: String,
        // autoFill: Boolean,
        comment: String,
        // append: String,
        // mask: String,
        type: String,
        rules: Array,
        search: [Object, Function],
        fieldLabel: String,
        placeholder: String,
        outlined: Boolean,
        // {
        //     type: Boolean,
        //     default: false
        // },
        disabled: Boolean,

        // replaceEngToRu: {
        //     type: Boolean,
        //     default: true
        // },

        // Ограничения ввода:
        isMoney: Boolean,
        isCyrilic: Boolean,
        isCyrilicIssued: Boolean,
        isCyrilicPlace: Boolean,
        isEngEmail: Boolean,
    },
    computed: {
        fieldValue: {
            get() {
                return this.value
            },
            set( val ) {
                this.$emit('input', val)
                clearTimeout(this.searchTimeout);

                this.searchTimeout = setTimeout(
                    () => {
                        this.search(this.fieldValue);
                    },
                    this.searchDelay
                );
            }
        },
        fieldItems() {
            let value = this.items.filter((item, i) => !(item.value === this.fieldValue && i > 0));

            return this.items[0]?.value ? value : [];
        },
        // translatedFieldLabel() {
        //     return this.$t(this.fieldLabel) || this.fieldLabel;
        // },
        fieldAttrs() {
            return {
                autocomplete: false,
                placeholder: this.placeholder,
                type: this.type,
                solo: !this.fieldLabel,
                label: this.fieldLabel,
                flat: true,
                outlined: this.outlined,
                readonly: this.menu,
                rules: this.rules,
                disabled: this.disabled,
                'hide-details': this.$isMobile ? 'auto' : false,
                // height: "47px",
                // 'background-color': "white",
                'validate-on-blur': true,
            }
        },
        isListActive() {
            return (this.isFocus && this.fieldItems.length > 0) 
                    || this.isMouseOver;
        }
    },
    data: () => ({
        isFocus: false,
        isMouseOver: false,
        // fieldValue: "",
        listKey: 0,
        searchTimeout: null,
        searchDelay: 300,
    }),
    mounted() {
        // if (this.forceValue) {
        //     this.fieldValue = this.forceValue;
        //     this.search(this.forceValue);
        // }

        // this.forceValue && (this.fieldValue = this.forceValue);
    },
    watch: {
        // forceValue(val) {
        //     this.$nextTick(
        //         () => this.fieldValue = val
        //     );
        //     // this.search(val);
        // },
        fieldItems( val ) {
            this.listKey=0;
        }
    },
    methods: {
        changeItem(val) {
            this.fieldValue = val;
            this.isFocus = false;
            this.isMouseOver = false;
        },
        changeItemByKey( e ) {
            const length = this.fieldItems.length - 1;
            
            e.key == "ArrowDown" && (this.listKey < length && this.listKey++);
            e.key == "ArrowUp" && (this.listKey > 0 && this.listKey--);

            this.isFocus = true;
            e.key =="Enter" && (
                this.fieldValue = this.fieldItems[this.listKey].value, 
                this.isFocus = false
            );
            e.key =="Escape" && (this.isFocus = false);

            // console.log(e?.key, this.listKey);
        },
        applyInputRestrictions(val) {
            let oldval = val;
            let key;

            if (this.isMoney) {
                val = val.replace(/\D/g, "");
            }
            if (this.isEngEmail) {
                val = val.replace(/[^a-zA-Z\-0-9.@]/g, "");
            }
            if (this.isCyrilic) {
                val = val.replace(/[^а-яА-ЯёЁ -]/g, "");
            }
            if (this.isCyrilicIssued) {
                val = val.replace(/[^0-9А-яЁё/\\(№\-.,")\s]/g, "");
            }
            if (this.isCyrilicPlace) {
                val = val.replace(/[^0-9А-яЁё("\-.)\s]/g, "");
            }
            if (this.replaceEngToRu) {
                key = oldval.replace(val, "");
                if (key.length == 1) {
                    val += replaceToCyrilic(key);
                }
            }
            return val;
        },
    },
};
</script>


